import React, { createContext, useContext, useState, useCallback } from "react"
import { track } from "../../analytics/mixpanel"

const WaitlistModalContext = createContext(null)

export function WaitlistModalProvider({ children }) {
  const [open, setOpen] = useState(false)

  const openModal = useCallback((source) => {
    track("Waitlist Modal Opened", { source: typeof source === "string" ? source : "unknown" })
    setOpen(true)
  }, [])
  const closeModal = useCallback(() => setOpen(false), [])

  return (
    <WaitlistModalContext.Provider value={{ open, openModal, closeModal }}>
      {children}
    </WaitlistModalContext.Provider>
  )
}

export function useWaitlistModal() {
  const ctx = useContext(WaitlistModalContext)
  if (!ctx) throw new Error("useWaitlistModal must be used within WaitlistModalProvider")
  return ctx
}
